module.exports = __webpack_public_path__ + "static/media/29FUNOV9.c2debdf9.jpg";